import React, { useState } from "react";
import Size120X600 from "./PreviewSize/Size120X600";
import Size180X600 from "./PreviewSize/Size180X600";
import Size300X250 from "./PreviewSize/Size300X250";
import Size720X300 from "./PreviewSize/Size720X300";
import Size970X250 from "./PreviewSize/Size970X250";
import Size970X90 from "./PreviewSize/Size970X90";
import Size300X600 from "./PreviewSize/Size300X600";

export default function BannerPreview({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  colorTextButton,
  imageBrand,
  logoBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  const parametersComponent = {
    banner,
    title,
    description,
    titleButton,
    colorButton,
    colorTextButton,
    imageBrand,
    logoBrand,
    backgroundColorDetailsArea,
    borderRadiusButton,
  };

  const bannerSize = `${banner.size.width}-${banner.size.height}`;

  switch (bannerSize) {
    case "120-600":
      return <Size120X600 {...parametersComponent} />;
      break;
    case "180-600":
      return <Size180X600 {...parametersComponent} />;
      break;
    case "300-250":
      return <Size300X250 {...parametersComponent} />;
      break;
    case "300-600":
      return <Size300X600 {...parametersComponent} />;
      break;
    case "720-300":
      return <Size720X300 {...parametersComponent} />;
      break;
    case "970-90":
      return <Size970X90 {...parametersComponent} />;
      break;
    case "970-250":
      return <Size970X250 {...parametersComponent} />;
      break;

    default:
      return <></>;
  }
}
